'use client';

import React, { useState, useEffect } from 'react';
import { ShieldCheck, Download } from 'lucide-react';

export default function AuditTrailHeader() {
  const [dateStr, setDateStr] = useState('');

  useEffect(() => {
    setDateStr(
      new Date()?.toLocaleDateString('en-IN', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    );
  }, []);

  return (
    <div className="flex items-center justify-between px-5 py-4 border-b border-border bg-card">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center">
          <ShieldCheck size={18} className="text-primary" />
        </div>
        <div>
          <h1 className="text-base font-bold text-foreground leading-tight">Audit Trail</h1>
          <p className="text-xs text-muted-foreground">{dateStr || 'Loading…'}</p>
        </div>
      </div>
      <button className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-border text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors">
        <Download size={13} />
        Export CSV
      </button>
    </div>
  );
}
